export default __webpack_public_path__ + "static/media/plain-sticker-s.c4be16c8.png";